<!-- eslint-disable vue/no-confusing-v-for-v-if -->
<template>
  <main class="main main--has-floating-buttons">
    <hm-col :grid="true" class="grid--row-gap" cols="12 6@tablet 9@desktop">
      <card v-if="!displayOptions.differentDates" :title="$t('pageCreateReservation.card.dates')" cols="12">
        <hm-col :grid="true" cols="12">
          <hm-input-date ref="startDate"
                         v-model="quoteRequest.arrivalDate"
                         :max-date="maxArrivalDate"
                         :label="$t('pageCreateReservation.arrivalDate')"
                         cols="12@mobile 6@tablet 2@desktop"
                         name="arrivalDate" />
          <hm-input-date ref="endDate"
                         v-model="quoteRequest.departureDate"
                         :min-date="quoteRequest.arrivalDate"
                         :max-date="maxDepartureDate"
                         :label="$t('pageCreateReservation.departureDate')"
                         cols="12@mobile 6@tablet 2@desktop"
                         name="departureDate" />
        </hm-col>
      </card>
      <card :title="$t('pageCreateReservation.card.searchCriteria')" cols="12">
        <hm-card-inner v-for="(res, idx) in roomRequests"
                       :title="$t('pageCreateReservation.card.room', {idx: idx+1})"
                       :key="res.id"
                       :deletable="roomRequests.length > 1"
                       @delete="deleteRoomRequest(res.id)">
          <hm-col :grid="true" cols="12">
            <hm-input-date v-if="displayOptions.differentDates"
                           v-model="res.arrivalDate"
                           :label="$t('pageCreateReservation.arrivalDate')"
                           cols="12@mobile 6@tablet 2@desktop"
                           name="arrivalDate" />
            <hm-input-date v-if="displayOptions.differentDates"
                           v-model="res.departureDate"
                           :label="$t('pageCreateReservation.departureDate')"
                           cols="12@mobile 6@tablet 2@desktop"
                           name="departureDate" />
            <hm-input-select v-if="displayOptions.roomSelectionMode"
                             v-model="res.roomNumber"
                             :label="$t('pageCreateReservation.roomNumber')"
                             name="roomNumber"
                             cols="12@mobile 6@tablet 2@desktop">
              <option v-for="item in hotelSettings.rooms.all(res.roomNumber)" :value="item.roomNumber" v-html="`${item.roomNumber} (${item.roomType.name[$shortLocale]})`"></option>
            </hm-input-select>
            <hm-input-select v-if="displayOptions.groupReservation"
                             v-model="res.roomTypeIds[0]"
                             :label="$t('pageCreateReservation.roomType')"
                             name="roomType"
                             cols="12@mobile 6@tablet 2@desktop">
              <option :value="null"></option>
              <option v-for="item in hotelSettings.roomTypes.all(res.roomTypeIds[0])" :value="item.id" v-html="item.name[$shortLocale]"></option>
            </hm-input-select>
            <!--
            <hm-input-select v-if="displayOptions.groupReservation" v-model="res.roomCount" :label="'Zimmeranzahl'" name="roomCount" cols="12@mobile 6@tablet 2@desktop">
              <option v-for="item in intArray(100)" :value="item" v-html="item" />
            </hm-input-select>
            -->
            <hm-input-select v-model="res.numAdults" :label="$t('pageCreateReservation.numAdults')" name="numAdults" cols="12@mobile 6@tablet 2@desktop">
              <option v-for="item in intArray(100)" :value="item" :disabled="item > (99 - res.numChildren)" v-html="item"></option>
            </hm-input-select>
            <hm-input-select v-if="hasLicense('ChildRates')"
                             v-model="res.numChildren"
                             :label="$t('pageCreateReservation.numChildren')"
                             name="numChildren"
                             cols="12@mobile 6@tablet 2@desktop"
                             @input="onUpdateNumChildren(res)"
                             @change="onUpdateNumChildren(res)">
              <option v-for="item in intArray(100)" :value="item" :disabled="item > (99 - res.numAdults)" v-html="item"></option>
            </hm-input-select>
            <hm-input-select v-for="child in intArray(res.numChildren)"
                             v-model="res.childAgeCategories[child+1]"
                             :label="$tc('pageCreateReservation.child', child, { count: child+1 })"
                             :key="child"
                             :required="true"
                             name="childAge"
                             cols="12@mobile 6@tablet 2@desktop"
                             @input="debouncedDoQuote">
              <option v-for="item in hotelSettings.ageCategories.all(res.childAgeCategories[child+1])" v-if="item.ageQualifier !== 'Adult'" :value="item.id" v-html="`${item.name[$shortLocale]} (${item.ageFrom} - ${item.ageUntil})`"></option>
              <option v-for="item in hotelSettings.ageCategories.all(res.childAgeCategories[child+1])" v-if="item.ageQualifier === 'Adult'" :value="item.id" v-html="`${item.name[$shortLocale]}`"></option>
            </hm-input-select>
          </hm-col>
        </hm-card-inner>
      </card>
      <hm-col :grid="true" class="grid--row-gap" cols="12">
        <card v-for="(roomRequest, idx) in roomRequests"
              :title="$t('pageCreateReservation.card.room', {idx: idx+1})"
              :key="`${roomRequest.id}_${resultKey}`"
              :ref="roomRequest.id"
              cols="12">
          <hm-card-inner v-if="quoteActive || isEmpty(offers[roomRequest.id])">
            <hm-col v-if="quoteActive" cols="12">
              <h1>{{ $t('pageCreateReservation.calculatingRates') }}</h1>
            </hm-col>
            <hm-col v-if="!quoteActive && isEmpty(offers[roomRequest.id])" cols="12">
              <h1>{{ $t('pageCreateReservation.noResults') }}</h1>
            </hm-col>
          </hm-card-inner>
          <hm-card-inner v-if="!quoteActive && !isEmpty(offers[roomRequest.id])" :full-size="true">
            <hm-table :sticky="true"
                      :hover="!displayOptions.groupReservation"
                      columns="5"
                      grid-template-columns="minmax(17fr, 1fr) minmax(17fr, 1fr) minmax(14rem, 0.75fr) minmax(14rem, 0.75fr) 7rem"
                      min-width="69rem">
              <template slot="table-head">
                <div class="hm-table__th">{{ $t('pageCreateReservation.quotes.roomType') }}</div>
                <div class="hm-table__th">{{ $t('pageCreateReservation.quotes.ratePlan') }}</div>
                <div class="hm-table__th text-right">{{ $t('pageCreateReservation.quotes.amountPerNight') }}</div>
                <div class="hm-table__th text-right">{{ $t('pageCreateReservation.quotes.totalAmount') }}</div>
                <div v-if="displayOptions.groupReservation" class="hm-table__th text-right">{{ $t('pageCreateReservation.quotes.roomCount') }}</div>
                <div v-else class="hm-table__th text-right">&nbsp;</div>
              </template>
              <template slot="default">
                <template v-for="offer in offers[roomRequest.id]">
                  <div :class="[{'hm-table__td--selected': offer.selected > 0}]" class="hm-table__td" @click="selectOffer(roomRequest.id, offer.offerId)">{{ findHotelSettingById('roomTypes', offer.roomTypeId).name[$shortLocale] }}</div>
                  <div class="hm-table__td" @click="selectOffer(roomRequest.id, offer.offerId)">{{ findHotelSettingById('ratePlans', offer.ratePlanId).name[$shortLocale] }}</div>
                  <div class="hm-table__td text-right" @click="selectOffer(roomRequest.id, offer.offerId)">{{ calculateAmount(offer) / numberOfNights(offer) | toCurrency }} {{ offer.unitPriceSummary.currency }}</div>
                  <div class="hm-table__td text-right" @click="selectOffer(roomRequest.id, offer.offerId)">{{ calculateAmount(offer) | toCurrency }} {{ offer.unitPriceSummary.currency }}</div>
                  <div v-if="displayOptions.groupReservation" class="hm-table__td text-right" @click="selectOffer(roomRequest.id, offer.offerId)">
                    <hm-input-select v-model="offer.selected"
                                     :label="$t('pageCreateReservation.selectedRooms')"
                                     name="selectedRooms"
                                     cols="12"
                                     class="hm-input--inline-block"
                                     @input="selectOffer">
                      <option :value="0" v-html="0"></option>
                      <option v-for="index in 99" :value="index" v-html="index"></option>
                    </hm-input-select>
                  </div>
                  <div v-else class="hm-table__td hm-table__td--icon text-right" @click="selectOffer(roomRequest.id, offer.offerId)"><icon v-if="offer.selected > 0" icon="save" /></div>
                </template>
              </template>
            </hm-table>
          </hm-card-inner>
        </card>
      </hm-col>
    </hm-col>
    <hm-col :grid="true" class="grid--row-gap" cols="12 6@tablet 3@desktop">
      <card :title="$t('pageCreateReservation.card.quoteOptions')" cols="12">
        <hm-col :grid="true" cols="12">
          <hm-input-toggle v-model="quoteOptions.ignoreRestrictions" :label="$t('pageCreateReservation.ignoreRestrictions')" cols="12" />
          <hm-input-toggle v-model="quoteOptions.ignoreOccupancy" :label="$t('pageCreateReservation.ignoreOccupancy')" cols="12" />
          <hm-input-toggle v-model="quoteOptions.ignoreInventory" :label="$t('pageCreateReservation.ignoreInventory')" cols="12" />
          <hm-input-toggle v-model="quoteOptions.showHiddenRates" :label="$t('pageCreateReservation.showHiddenRates')" cols="12" />
          <hm-input-toggle v-if="false"
                           v-model="displayOptions.differentDates"
                           :label="$t('pageCreateReservation.differentDates')"
                           :help="$t('pageCreateReservation.differentDates_help')"
                           cols="12" />
          <hm-input-toggle v-model="displayOptions.roomSelectionMode" :label="$t('pageCreateReservation.roomSelectionMode')" :help="$t('pageCreateReservation.roomSelectionMode_help')" cols="12" />
          <hm-input-toggle v-model="displayOptions.groupReservation" :label="$t('pageCreateReservation.groupReservation')" cols="12" />
          <hm-input-select v-if="hasLicense('DiscountCode')" v-model="quoteRequest.discountCode" :label="$t('pageCreateReservation.discountCode')" cols="12">
            <option :value="null"></option>
            <template v-for="it in (hotelSettings.discountCodes || [])">
              <option :key="it.code" :value="it.code">{{ it.code }}</option>
            </template>
          </hm-input-select>
        </hm-col>
      </card>
      <card v-if="!displayOptions.differentDates && !isEmpty(roomTypeAvailability)" :title="$t('pageCreateReservation.card.availabilities')" cols="12">
        <label-value-dotted v-for="avail in roomTypeAvailability"
                            v-if="!findHotelSettingById('roomTypes', avail.roomTypeId).deleted || avail.count > 0"
                            :value="avail.count"
                            :label="findHotelSettingById('roomTypes', avail.roomTypeId).name[$shortLocale]"
                            :key="avail.roomTypeId" />
      </card>
      <card v-if="!displayOptions.differentDates && !isEmpty(selectedRoomTypes)" :title="$t('pageCreateReservation.card.selectedRoomTypes')" cols="12">
        <label-value-dotted v-for="value in selectedRoomTypes"
                            :value-class="[{'color--red': value.remaining < 0}]"
                            :value="value.selected"
                            :class="[{'label-value-dotted__wrapper--bold color--red': value.remaining < 0}]"
                            :label="findHotelSettingById('roomTypes', value.roomTypeId).name[$shortLocale]"
                            :key="value.roomTypeId" />
        <label-value-dotted :value="selectedRoomTypesCount" :label="$t('pageCreateReservation.selectedRoomTypes.total')" class="label-value-dotted__wrapper--sum label-value-dotted__wrapper--bold" />
      </card>
    </hm-col>
    <hm-floating-buttons>
      <hm-floating-button :label="$t('pageCreateReservation.actions.addRoom')" icon="plus" color="blue" @click="addNewRoomRequest()" />
      <hm-floating-button :disabled="!canContinue()"
                          :key="`${resultKey}_offer`"
                          :label="canContinue() ? $t('pageCreateReservation.actions.createOffer') : $t('pageCreateReservation.actions.createOfferDisabled')"
                          icon="save"
                          color="mint"
                          @click="createOffer()" />
      <hm-floating-button :disabled="!canContinue()"
                          :key="resultKey"
                          :label="canContinue() ? $t('pageCreateReservation.actions.createReservation') : $t('pageCreateReservation.actions.createReservationDisabled')"
                          icon="forward-1c"
                          color="mint"
                          @click="createDraftReservation()" />
    </hm-floating-buttons>
  </main>
</template>

<script>
/* eslint func-names: 0 */

import HotelmeisterMixin from '@/mixins/HotelmeisterMixin';
import { groupBy, uniqBy, isNil, isEmpty, get, head, debounce, cloneDeep } from 'lodash';
import uuid from 'uuid';
import Icon from '../lib/util/Icon';
import PageMixin from '../../mixins/PageMixin';

export default {
  name: 'PageCreateReservation',
  components: { Icon },
  mixins: [HotelmeisterMixin, PageMixin],


  data() {
    return {
      debouncedUpdateRoomTypeAvailability: null,
      debouncedDoQuote: null,
      confirmationNumber: null,
      quoteActive: false,
      draftReservations: [],
      roomTypeAvailability: [],
      resultKey: uuid.v4(),
      quoteRequest: {
        arrivalDate: null,
        departureDate: null,
        discountCode: null,
      },
      roomRequests: [],
      offers: {},
      quoteOptions: {
        ignoreInventory: false,
        ignoreRestrictions: false,
        ignoreOccupancy: false,
        showHiddenRates: false,
      },
      displayOptions: {
        differentDates: false,
        roomSelectionMode: false,
        groupReservation: false,
      },
      selectedRoomTypes: null,
      selectedRoomTypesCount: null,
    };
  },

  computed: {
    maxArrivalDate: function () {
      return this.$moment().add(this.hotelSettings.details.futureDates - 1, 'days').format('YYYYMMDD');
    },
    maxDepartureDate: function () {
      return this.$moment().add(this.hotelSettings.details.futureDates, 'days').format('YYYYMMDD');
    },
    pageShortcuts: function () {
      return {
        'Ctrl+←': this.$t('pageCreateReservations.shortcuts.back1d'),
        'Ctrl+→': this.$t('pageCreateReservations.shortcuts.forward1d'),
        'Alt+1': this.$tc('pageCreateReservations.shortcuts.departureIsArrivalPlusXd', 1, { idx: 1 }),
        'Alt+2': this.$tc('pageCreateReservations.shortcuts.departureIsArrivalPlusXd', 2, { idx: 2 }),
        'Alt+3': this.$tc('pageCreateReservations.shortcuts.departureIsArrivalPlusXd', 3, { idx: 3 }),
        'Alt+4': this.$tc('pageCreateReservations.shortcuts.departureIsArrivalPlusXd', 4, { idx: 4 }),
        'Alt+5': this.$tc('pageCreateReservations.shortcuts.departureIsArrivalPlusXd', 5, { idx: 5 }),
        'Alt+6': this.$tc('pageCreateReservations.shortcuts.departureIsArrivalPlusXd', 6, { idx: 6 }),
        'Alt+7': this.$tc('pageCreateReservations.shortcuts.departureIsArrivalPlusXd', 7, { idx: 7 }),
        'Alt+8': this.$tc('pageCreateReservations.shortcuts.departureIsArrivalPlusXd', 8, { idx: 8 }),
        'Alt+9': this.$tc('pageCreateReservations.shortcuts.departureIsArrivalPlusXd', 9, { idx: 9 }),
      };
    },
  },

  watch: {
    resultKey: function () {
      this.updateSelectedRoomTypes();
    },
    quoteOptions: {
      handler: function () {
        this.debouncedDoQuote();
      },
      deep: true,
    },
    roomRequests: {
      handler: function () {
        this.debouncedDoQuote();
      },
      deep: true,
    },
    'quoteRequest.arrivalDate': function () {
      this.debouncedUpdateRoomTypeAvailability();
      this.debouncedDoQuote();
    },
    'quoteRequest.departureDate': function () {
      this.debouncedUpdateRoomTypeAvailability();
      this.debouncedDoQuote();
    },
    'displayOptions.differentDates': function (newVal, oldVal) {
      if (newVal === false) {
        this.roomRequests.forEach((it) => {
          it.arrivalDate = null;
          it.departureDate = null;
        });
        this.debouncedUpdateRoomTypeAvailability();
        this.debouncedDoQuote();
      } else {
        this.roomTypeAvailability = [];
      }
    },
    'displayOptions.roomSelectionMode': function (newVal, oldVal) {
      if (newVal === true) {
        this.displayOptions.groupReservation = false;
        this.roomRequests.forEach((it) => { it.roomTypeIds = []; });
      } else {
        this.roomRequests.forEach((it) => { it.roomNumber = null; });
      }
      this.debouncedDoQuote();
    },
    'displayOptions.groupReservation': function (newVal, oldVal) {
      if (newVal === true) {
        this.displayOptions.roomSelectionMode = false;
      } else {
        this.roomRequests.forEach((it) => { it.roomCount = 1; });
      }
      this.debouncedDoQuote();
    },
    'quoteRequest.discountCode': function () {
      this.debouncedDoQuote();
    },
  },

  created: function () {
    this.debouncedUpdateRoomTypeAvailability = debounce(this.updateRoomTypeAvailability, 250);
    this.debouncedDoQuote = debounce(this.doQuote, 250);

    this.confirmationNumber = isNil(this.$route.params) || isEmpty(this.$route.params.confirmationNumber) ? null : this.$route.params.confirmationNumber;

    if (!isNil(this.$route.params.reservations)) {
      this.draftReservations = this.$route.params.reservations;
      this.roomRequests = this.draftReservations.map(it => ({
        id: it.reservationId,
        arrivalDate: it.checkInDate,
        departureDate: it.checkOutDate,
        roomNumber: it.roomNumber,
        roomTypeIds: [],
        numAdults: it.numAdults,
        numChildren: 0,
        roomCount: 1,
        childAgeCategories: {},
      }));

      this.quoteRequest.arrivalDate = head(this.roomRequests).arrivalDate;
      this.quoteRequest.departureDate = head(this.roomRequests).departureDate;
    } else {
      this.quoteRequest.arrivalDate = isNil(this.$route.params) || isEmpty(this.$route.params.checkInDate) ? this.$moment().format('YYYYMMDD') : this.$route.params.checkInDate;
      this.quoteRequest.departureDate = isNil(this.$route.params) || isEmpty(this.$route.params.checkOutDate) ? this.$moment().add(1, 'days').format('YYYYMMDD') : this.$route.params.checkOutDate;
      this.addNewRoomRequest();
    }

    this.displayOptions.differentDates = uniqBy(this.roomRequests, 'arrivalDate').length > 1 || uniqBy(this.roomRequests, 'departureDate').length > 1;
    this.displayOptions.roomSelectionMode = this.roomRequests.map(it => it.roomNumber).filter(it => !isNil(it)).length > 0;

    this.debouncedDoQuote();

    this.$serviceBus.$on('shortcut.pageRight', this.add1Day);
    this.$serviceBus.$on('shortcut.pageLeft', this.subtract1Day);
    this.$serviceBus.$on('shortcut.count', this.setDays);
  },

  beforeDestroy: function () {
    this.$serviceBus.$off('shortcut.pageRight', this.add1Day);
    this.$serviceBus.$off('shortcut.pageLeft', this.subtract1Day);
    this.$serviceBus.$off('shortcut.count', this.setDays);
  },

  methods: {
    setDays(dayCount) {
      if (!this.displayOptions.differentDates && dayCount > 0) {
        this.quoteRequest.departureDate = this.$moment(this.quoteRequest.arrivalDate, 'YYYYMMDD').add(dayCount, 'days').format('YYYYMMDD');
      }
    },
    add1Day() {
      if (!this.displayOptions.differentDates) {
        if (!isNil(this.$refs) && !isNil(this.$refs.startDate) && !this.$refs.startDate.hasFocus && !isNil(this.$refs.endDate) && !this.$refs.endDate.hasFocus) {
          this.quoteRequest.arrivalDate = this.$moment(this.quoteRequest.arrivalDate, 'YYYYMMDD').add(1, 'days').format('YYYYMMDD');
        }
      }
    },
    subtract1Day() {
      if (!this.displayOptions.differentDates) {
        if (!isNil(this.$refs) && !isNil(this.$refs.startDate) && !this.$refs.startDate.hasFocus && !isNil(this.$refs.endDate) && !this.$refs.endDate.hasFocus) {
          this.quoteRequest.arrivalDate = this.$moment(this.quoteRequest.arrivalDate, 'YYYYMMDD').add(-1, 'days').format('YYYYMMDD');
        }
      }
    },
    createOffer: function () {
      this.axios.post(
        this.serviceUrls.offer.create(this),
        {
          offers: this.roomRequests
            .flatMap(roomRequest => (roomRequest.id in this.offers ? this.offers[roomRequest.id].filter(it => it.selected > 0) : []))
            .map((it) => {
              it.roomCount = it.selected;
              it.arrivalDate = it.sArrivalDate;
              it.departureDate = it.sDepartureDate;
              it.discount = {
                discountCode: this.quoteRequest.discountCode,
              };
              return it;
            }),
          confirmationNumber: this.confirmationNumber,
        },
      )
        .then((response) => {
          this.$router.push(
            {
              name: 'offer',
              params: {
                guestOfferId: response.data.data,
              },
            },
          );
        });
    },
    createDraftReservation: function () {
      this.$router.push(
        {
          name: 'draftReservation',
          params: {
            selectedOffers: this.roomRequests.flatMap(roomRequest => (roomRequest.id in this.offers ? this.offers[roomRequest.id].filter(it => it.selected > 0) : [])),
            confirmationNumber: this.confirmationNumber,
            discountCode: this.quoteRequest.discountCode,
          },
        },
      );
    },
    updateSelectedRoomTypes: function () {
      const ret = { };
      let total = 0;
      if (!isNil(this.roomRequests)) {
        this.roomRequests.forEach((roomRequest) => {
          if (!isNil(this.offers) && !isNil(this.offers[roomRequest.id])) {
            this.offers[roomRequest.id].forEach((offer) => {
              if (offer.selected > 0 && offer.roomTypeId in ret) {
                ret[offer.roomTypeId].selected += offer.selected;
                total += offer.selected;
              } else if (offer.selected > 0) {
                ret[offer.roomTypeId] = {
                  roomTypeId: offer.roomTypeId,
                  selected: offer.selected,
                };
                total += offer.selected;
              }
            });
          }
        });
      }

      if (!isNil(this.roomTypeAvailability)) {
        this.roomTypeAvailability.forEach((availability) => {
          if (availability.roomTypeId in ret) {
            ret[availability.roomTypeId].available = availability.count;
            ret[availability.roomTypeId].remaining = availability.count - ret[availability.roomTypeId].selected;
          }
        });
      }

      this.selectedRoomTypesCount = total;
      this.selectedRoomTypes = ret;
    },
    canContinue: function () {
      // eslint-disable-next-line no-shadow
      return !this.quoteActive
        && this.roomRequests
          .map(it => it.id)
          .filter(it => !isNil(this.offers[it]) && !isNil(this.offers[it].find(itInner => itInner.selected > 0)))
          .length === this.roomRequests.length;
    },
    doQuote: function () {
      if (this.quoteActive) {
        this.debouncedDoQuote();
        return;
      } else if (isNil(this.quoteRequest.arrivalDate) || isNil(this.quoteRequest.departureDate)) {
        this.offers = {};
        this.resultKey = uuid.v4();
        return;
      }

      this.quoteActive = true;
      const quoteRequest = {
        arrivalDate: this.quoteRequest.arrivalDate,
        departureDate: this.quoteRequest.departureDate,
        sourceChannel: 'Internal',
        discountCode: this.quoteRequest.discountCode,
        roomRequests: cloneDeep(this.roomRequests).map((it) => {
          it.ignoreInventory = this.quoteOptions.ignoreInventory;
          it.ignoreRestrictions = this.quoteOptions.ignoreRestrictions;
          it.ignoreOccupancy = this.quoteOptions.ignoreOccupancy;
          it.showHiddenRates = this.quoteOptions.showHiddenRates;
          return it;
        }),
      };

      this.axios.post(this.serviceUrls.quote(this), quoteRequest)
        .then((response) => {
          const groupedResponse = groupBy(response.data.data.offers, it => it.roomRequestId);
          quoteRequest.roomRequests.map(it => it.id).forEach(((it) => {
            groupedResponse[it].forEach((offer) => { offer.selected = 0; });
            if (!this.displayOptions.groupReservation) {
              if (!isNil(this.offers[it])) {
                // eslint-disable-next-line no-shadow
                const selected = this.offers[it].find(it => it.selected > 0);
                if (!isNil(selected) && !isNil(groupedResponse[it])) {
                  // eslint-disable-next-line no-shadow
                  groupedResponse[it].filter(it => it.roomTypeId === selected.roomTypeId && it.ratePlanId === selected.ratePlanId)
                    .forEach((itInner) => { itInner.selected = 1; });
                }
                if (isNil(selected) && !isNil(groupedResponse[it])) {
                  head(groupedResponse[it]).selected = 1;
                }
              } else if (!isNil(groupedResponse[it])) {
                head(groupedResponse[it]).selected = 1;
              }
            }
            this.offers[it] = groupedResponse[it];
          }));
          this.resultKey = uuid.v4();
          this.quoteActive = false;
        })
        .catch((error) => {
          this.quoteActive = false;
          quoteRequest.roomRequests.map(it => it.id).forEach(((it) => {
            this.offers[it] = [];
          }));
          this.showMessages(error.response);
        });
    },
    selectOffer: function (roomRequestId, offerId) {
      if (!this.displayOptions.groupReservation) {
        this.offers[roomRequestId].forEach((it) => { it.selected = (it.offerId === offerId ? 1 : 0); });
        this.resultKey = uuid.v4();
      } else {
        this.updateSelectedRoomTypes();
      }
    },
    calculateAmount: function (offer) {
      if (!isNil(offer.totalAmount)) return offer.totalAmount;

      let ret = 0.0;
      if (!isNil(offer.unitPriceSummary) && !isNil(offer.unitPriceSummary.amount)) {
        ret += offer.unitPriceSummary.amount;
      }
      if (this.hotelSettings.details.currency !== 'USD' && !isNil(offer.unitPriceSummary) && !isNil(offer.unitPriceSummary.excludedTaxAmount)) {
        ret += offer.unitPriceSummary.excludedTaxAmount;
      }
      if (!isNil(offer.shoppingCartSummary) && !isNil(offer.shoppingCartSummary.excludedTaxAmount)) {
        ret += offer.shoppingCartSummary.amount;
      }
      if (this.hotelSettings.details.currency !== 'USD' && !isNil(offer.shoppingCartSummary) && !isNil(offer.shoppingCartSummary.excludedTaxAmount)) {
        ret += offer.shoppingCartSummary.excludedTaxAmount;
      }

      offer.totalAmount = ret;

      return ret;
    },
    numberOfNights: function (offer) {
      if (!isNil(offer.numberOfNights)) return offer.numberOfNights;

      offer.numberOfNights = this.$moment.duration(this.$moment(offer.sDepartureDate, 'YYYYMMDD').diff(offer.sArrivalDate)).asDays();

      return offer.numberOfNights;
    },
    updateRoomTypeAvailability: function () {
      if (this.displayOptions.differentDates) {
        this.roomTypeAvailability = [];
      }

      const days = this.$moment.duration(this.$moment(this.quoteRequest.departureDate, 'YYYYMMDD').diff(this.quoteRequest.arrivalDate)).asDays();

      this.axios.get(this.serviceUrls.roomTypePlan(this), {
        params: {
          start: this.quoteRequest.arrivalDate,
          limit: Math.abs(Math.round(days)) - 1,
        },
        headers: {
          Accept: 'application/x-protobuf',
        },
        responseType: 'arraybuffer',
      }).then((response) => {
        this.roomTypeAvailability = [];

        const keys = isNil(response.data.data.ByRoomType) ? [] : Object.keys(response.data.data.ByRoomType);
        this.hotelSettings.roomTypes.all()
          .forEach((roomType) => {
            const count = head(
              keys.map(date => response.data.data.ByRoomType[date].value[roomType.id])
                .sort((a, b) => a - b),
            );

            this.roomTypeAvailability.push({
              roomTypeId: roomType.id,
              count: count,
            });
          });
      });
    },
    isEmpty: function (value) {
      return isEmpty(value);
    },
    intArray: function (value, offset = 0) {
      return [...Array(value).keys()].map(x => x + offset);
    },
    onUpdateNumChildren: function (res) {
      const children = this.intArray(res.numChildren, 1);
      const defaultAgeCategoryId = isNil(this.hotelSettings.ageCategories.all().find(it => it.ageQualifier !== 'Adult'))
        ? this.hotelSettings.ageCategories.all().find(it => it.ageQualifier === 'Adult').id
        : this.hotelSettings.ageCategories.all().find(it => it.ageQualifier !== 'Adult').id;
      children.forEach((it) => {
        if (isEmpty(get(res.childAgeCategories, it, null))) {
          res.childAgeCategories[it] = defaultAgeCategoryId;
        }
      });
    },
    addNewRoomRequest: function () {
      this.roomRequests.push({
        id: uuid.v4(),
        arrivalDate: null,
        departureDate: null,
        roomNumber: null,
        roomTypeIds: [],
        numAdults: 2,
        numChildren: 0,
        roomCount: 1,
        childAgeCategories: {},
      });
      this.resultKey = uuid.v4();
      this.debouncedDoQuote();
    },
    deleteRoomRequest: function (roomRequestId) {
      // not using lodash remove function because it does not trigger vue change
      this.roomRequests = this.roomRequests.filter(it => it.id !== roomRequestId);
      this.resultKey = uuid.v4();
      this.debouncedDoQuote();
    },
  },
};
</script>

<!-- Scoped SCSS  -->
<style lang="scss" scoped>
  @import '~styles/import';

  .hm-table__td {
    &--selected {
      &:before {
        content: ' ';
        left: 0;
        right: 0;
        background: $lightgray;
        height: 4.8rem;
        position: absolute;
        z-index: -1;
      }
    }
    &--icon {
      display: flex;
      flex-direction: column;

      .hm-icon {
        display: flex;
        flex-direction: column;
        flex: 1;
        justify-content: center;
        width: 100%;
        height: 100%;
      }

      @include icon-color($mint);
    }
  }

</style>

<style lang="scss">
  @import '~styles/import';
</style>



// WEBPACK FOOTER //
// src/components/pages/PageCreateReservation.vue